module.exports = __webpack_public_path__ + "static/media/photography04.0577102a.png";